import { formatLinkBlockToUrl, formatUrlWithActiveFund } from '$utilities/format';
import { isLocalURL } from '$utilities/browser';
import PropTypes from 'prop-types';
import React from 'react';
import { getSiteContext } from '$utilities/site-context';


/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Footer = ({
    contact,
    funds
}) => {
    const siteContext = getSiteContext();

    return (
        <footer className='relative layout-container pt-70 pb-100 sm:pb-70 md:py-80'>
            <div className='flex flex-wrap layout-negative-margin'>
                {/* Contact */}
                <div className='w-full sm:w-4/12 layout-item-padding order-2 sm:order-1 mt-60 sm:mt-0'>
                    {contact && (
                        <div
                            className='rich-text footer-contact'
                            dangerouslySetInnerHTML={{ __html: contact}}/>
                    )}
                </div>

                {/* Spacer */}
                <div className='hidden sm:block sm:w-2/12 sm:order-2'/>

                <div className='flex w-12/12 order-1 sm:order-3 sm:w-6/12'>
                    {/* Funds */}
                    <div className='w-6/12 layout-item-padding'>
                        <div className='flex flex-col gap-y-[5px]'>
                            {funds?.length > 0 && funds.map((link, i) => {
                                const href = formatUrlWithActiveFund(formatLinkBlockToUrl(link.link));
                                const target = isLocalURL(href) ? '_self' : '_blank';
                                return (
                                    <a
                                        className='inline-block footer-links'
                                        href={href}
                                        key={i}
                                        target={target}>
                                        {link.label || link.link?.page?.title }
                                    </a>
                                );
                            })}
                        </div>
                    </div>

                    {/* Links */}
                    <div className='w-6/12 layout-item-padding'>
                        <div className='flex flex-col gap-y-[5px]'>
                            {siteContext.footerLinks?.length > 0 && siteContext.footerLinks.map((link, i) => {
                                const href = formatUrlWithActiveFund(formatLinkBlockToUrl(link.link));
                                const target = isLocalURL(href) ? '_self' : '_blank';
                                return (
                                    <a
                                        className='inline-block footer-links'
                                        href={href}
                                        key={i}
                                        target={target}>
                                        {link.label || link.link?.page?.title }
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const navigationLink = PropTypes.shape({
    page: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        url: PropTypes.string,
    }),
});

const propTypes = {
    contact: PropTypes.string,
    funds: PropTypes.arrayOf(navigationLink),
};

Footer.propTypes = propTypes;

export default Footer;
